export default "__VITE_ASSET__5ab6510c__"